import React, { useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  ListSubheader,
} from "@mui/material";
import FlavorInfoModal from "./FlavorInfoModal";

const FlavorDropdown = ({ flavors, selectedFlavorId, onChange }) => {
  const [showFlavorModal, setShowFlavorModal] = useState(false);

  return (
    <Box sx={{ mt: 3 }}>
      {/* Static Label */}
      <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
        Flavor
      </Typography>

      <Box sx={{ display: "flex", gap: 2 }}>
        {/* Dropdown */}
        {/* <FormControl fullWidth>
          <Select
            value={selectedFlavorId}
            onChange={onChange}
            displayEmpty
            sx={{
              borderRadius: "12px",
              height: 60,
              fontWeight: 500,
              color: selectedFlavorId ? "black" : "#999",
              backgroundColor: "#fff",
              zIndex: 1,
              "& .MuiSelect-select": {
                zIndex: 1,
              },
              "&.Mui-focused": {
                zIndex: 1,
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  zIndex: 2000,
                },
              },
            }}
            renderValue={(selectedId) => {
              const selected = flavors.find((f) => f._id === selectedId);
              return selected ? selected.displayName : "Select";
            }}>
            {[...flavors]
              .sort((a, b) => (a.price || 0) - (b.price || 0))
              .map((flavor) => (
                <MenuItem key={flavor._id} value={flavor._id}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}>
                    <Typography variant="body2">
                      {flavor.displayName}
                      {flavor.price > 0 && ` +$${flavor.price.toFixed(2)}`}
                    </Typography>
                    {flavor.isPremium && (
                      <Box
                        sx={{
                          ml: 2,
                          px: 1,
                          py: 0.25,
                          backgroundColor: "#FFEAE7",
                          borderRadius: "8px",
                        }}>
                        <Typography
                          variant="caption"
                          sx={{ color: "#FD7762", fontWeight: 600 }}>
                          Premium
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </MenuItem>
              ))}
          </Select>
        </FormControl> */}

        <FormControl fullWidth>
          <Select
            value={selectedFlavorId}
            onChange={onChange}
            displayEmpty
            sx={{
              borderRadius: "12px",
              height: 60,
              fontWeight: 500,
              color: selectedFlavorId ? "black" : "#999",
              backgroundColor: "#fff",
              zIndex: 1,
              "& .MuiSelect-select": { zIndex: 1 },
              "&.Mui-focused": { zIndex: 1 },
            }}
            MenuProps={{
              PaperProps: {
                sx: { zIndex: 2000 },
              },
            }}
            renderValue={(selectedId) => {
              const selected = flavors.find((f) => f._id === selectedId);
              return selected ? selected.displayName : "Select";
            }}>
            {/* Grouped Flavors */}
            {[
              {
                title: "Included Flavors",
                items: flavors.filter((f) => f.basePriceIncluded),
              },
              {
                title: "Extra Flavors",
                items: flavors.filter(
                  (f) => !f.basePriceIncluded && !f.isPremium
                ),
              },
              {
                title: "Premium Flavors",
                items: flavors.filter((f) => f.isPremium),
              },
            ]
              .filter((group) => group.items.length > 0)
              .map((group) => [
                <ListSubheader key={group.title} disableSticky>
                  {group.title}
                </ListSubheader>,
                ...group.items.map((flavor) => (
                  <MenuItem key={flavor._id} value={flavor._id}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}>
                      <Typography variant="body2">
                        {flavor.displayName}
                        {!flavor.basePriceIncluded &&
                          ` +$${flavor.price.toFixed(2)}`}
                      </Typography>
                      {flavor.isPremium && (
                        <Box
                          sx={{
                            ml: 2,
                            px: 1,
                            py: 0.25,
                            backgroundColor: "#FFEAE7",
                            borderRadius: "8px",
                          }}>
                          <Typography
                            variant="caption"
                            sx={{ color: "#FD7762", fontWeight: 600 }}>
                            Premium
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </MenuItem>
                )),
              ])}
          </Select>
        </FormControl>

        {/* More Info Button */}
        <Button
          variant="outlined"
          onClick={() => setShowFlavorModal(true)}
          sx={{
            height: 60,
            px: 3,
            borderRadius: "12px",
            color: "#FD7762",
            borderColor: "#FD7762",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "#FFDDD9",
              borderColor: "#FD7762",
            },
          }}>
          More Info
        </Button>
      </Box>

      {/* Flavor Info Modal */}
      <FlavorInfoModal
        open={showFlavorModal}
        onClose={() => setShowFlavorModal(false)}
        flavors={flavors}
      />
    </Box>
  );
};

export default FlavorDropdown;
